/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TokenEnum {
    ACCESS = 'ACCESS',
    REFRESH = 'REFRESH',
    FRESH = 'FRESH',
}
